import API from './API.js';
export default class MasterReferences extends API {
    constructor() {
        super('masterReferences');
    }

}
